export enum Roles {
  Guest = 0,
  User = 1,
  Manager = 2,
  Admin = 3
}
